// 2_components/products_block_price_reviews.js
// Product listing (.products-block .product) enhancements: moves the crossed-out
// standard price into the final price, appends the review count next to the stars,
// and renders the measure-unit amount + price-per-unit from the downloaded filter
// data. Re-runs on Shoptet, Luigi's Box and Raventic content-replacement events.

export function init() {
	if (!window.NAT?.utils?.downloadAndSaveMeasureUnitFilter) {
		console.warn("[NAT] products_block_price_reviews.js: window.NAT.utils.downloadAndSaveMeasureUnitFilter missing — check load order");
		return;
	}

	measureUnitFromFiltersProducts();
	document.addEventListener("ShoptetDOMContentLoaded", function (event) {
		actionPriceToFinalPriceAndReviewsNumber();
		measureUnitFromFiltersProducts();
	});
	document.addEventListener("luigiSearchDone", function (event) {
		actionPriceToFinalPriceAndReviewsNumber();
		measureUnitFromFiltersProducts();
	});
	document.addEventListener("RAVENTIC SEARCH RESULTS TRANSFORMED", function (event) {
		actionPriceToFinalPriceAndReviewsNumber();
		measureUnitFromFiltersProducts();
	});

	actionPriceToFinalPriceAndReviewsNumber();
}

function actionPriceToFinalPriceAndReviewsNumber() {
	const allProductsInProductsBlock = document.querySelectorAll(".products-block .product");
	if (!allProductsInProductsBlock || allProductsInProductsBlock.length === 0) {
		return; // No products found
	}
	allProductsInProductsBlock.forEach((product) => {
		if (product.classList.contains("product-edited-price-reviews")) {
			return; // Skip if already processed
		}
		product.classList.add("product-edited-price-reviews");
		const priceStandard = product.querySelector(".flag-discount .price-standard");
		const priceFinal = product.querySelector(".price-final");
		if (priceStandard && priceFinal) {
			priceFinal.appendChild(priceStandard);
		}
		const starWrapper = product.querySelector(".stars-wrapper");
		if (starWrapper) {
			const reviewsNumber = starWrapper.getAttribute("data-micro-rating-count");
			if (reviewsNumber) {
				const reviewsNumberSpan = document.createElement("span");
				reviewsNumberSpan.className = "reviews-number";
				reviewsNumberSpan.innerHTML = reviewsNumber + "x";
				starWrapper.appendChild(reviewsNumberSpan);
			}
		}
	});
}

async function measureUnitFromFiltersProducts() {
	const allProductsInProductsBlock = document.querySelectorAll(".products-block .product");
	if (!allProductsInProductsBlock || allProductsInProductsBlock.length === 0) {
		return; // No products found
	}
	await window.NAT.utils.downloadAndSaveMeasureUnitFilter();
	const productFilterData = window.NAT.measureFiltersData;
	if (!productFilterData || productFilterData.length === 0) {
		return; // No filter data available
	}

	allProductsInProductsBlock.forEach((product) => {
		if (product.classList.contains("product-edited-measure")) {
			return; // Skip if already processed
		}
		product.classList.add("product-edited-measure");
		const productCodeForFilter = product.querySelector("span[data-micro='sku']")?.textContent.trim();
		if (!productCodeForFilter) {
			console.warn("Product code not found for a product.");
			return;
		}

		const amountText = productFilterData.find((item) => item.code === productCodeForFilter)?.value;
		if (!amountText) {
			console.warn("No measure unit found for product code:", productCodeForFilter);
			return;
		}

		// Convert comma to dot, then extract the number and unit
		const normalizedAmountText = amountText.replace(",", ".").trim();

		// Extract the numeric part (including decimal)
		const productMeasureAmount = normalizedAmountText.match(/[\d.]+/) ? normalizedAmountText.match(/[\d.]+/)[0] : "";

		// Extract the unit part (letters and spaces after the number)
		const productMeasureUnit = normalizedAmountText.replace(/[\d.\s]+/, "").trim();

		const ratingsWrapper = product.querySelector(".ratings-wrapper");
		const measureUnitSpan = document.createElement("span");
		if (ratingsWrapper) {
			// Create a new span element to display the amount
			measureUnitSpan.className = "product-measure-unit";
			measureUnitSpan.textContent = amountText;

			// Append the amount span to the ratings wrapper
			ratingsWrapper.appendChild(measureUnitSpan);
		}

		const pricePerUnitDiv = document.createElement("div");
		pricePerUnitDiv.className = "product-price-per-unit";
		const prices = product.querySelector(".prices");

		const priceFinal = product.querySelector(".price-final strong");
		let priceFinalValue;

		if (priceFinal) {
			// Extract the text content, trim it, and remove everything but numbers
			priceFinalValue = priceFinal.textContent.trim().replace(/[^\d.,]/g, ""); // Keep only digits, commas, and dots
			priceFinalValue = parseFloat(priceFinalValue.replace(",", ".")).toFixed(2);
		}

		// Plural -> singular map for the active language (object, not a string)
		const singleMeasuringUnit = window.NAT.translations("measuringUnitSingulars");
		let ignoredMeasuringUnits = [];
		if (window.NAT.lang === "cs" || window.NAT.lang === "sk") {
			ignoredMeasuringUnits = ["ks"];
		}
		if (window.NAT.lang === "pl") {
			ignoredMeasuringUnits = ["szt"];
		}

		if (ignoredMeasuringUnits.includes(productMeasureUnit)) {
			measureUnitSpan.style.display = "none";
			return; // Skip processing for ignored units
		}

		let pricePerUnit_Unit;

		let foundUnitMatch = false;

		// Iterate over the keys in the object
		for (const key in singleMeasuringUnit) {
			if (productMeasureUnit.includes(key)) {
				foundUnitMatch = true;
				pricePerUnit_Unit = singleMeasuringUnit[key];
				break; // Exit the loop once a match is found
			}
		}
		if (!foundUnitMatch) {
			// If no match is found, use the original measure unit
			pricePerUnit_Unit = productMeasureUnit;
		}

		const pricePerUnit_Value = priceFinalValue / productMeasureAmount;

		const pricePerUnit_ValueSpan = document.createElement("span");
		pricePerUnit_ValueSpan.className = "product-price-per-unit-value";

		if (window.NAT.lang === "cs") {
			pricePerUnit_ValueSpan.textContent =
				pricePerUnit_Value.toFixed(2).replace(".", ",") + " Kč / 1 " + pricePerUnit_Unit;
		}
		if (window.NAT.lang === "sk") {
			pricePerUnit_ValueSpan.textContent =
				pricePerUnit_Value.toFixed(2).replace(".", ",") + " € / 1 " + pricePerUnit_Unit;
		}
		if (window.NAT.lang === "pl") {
			pricePerUnit_ValueSpan.textContent =
				pricePerUnit_Value.toFixed(2).replace(".", ",") + " zł / 1 " + pricePerUnit_Unit;
		}

		if (prices && pricePerUnitDiv) {
			prices.appendChild(pricePerUnitDiv);
			pricePerUnitDiv.appendChild(pricePerUnit_ValueSpan);
		}
	});
}
